import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useBodyScrollLock } from "../../hooks/useBodyScrollLock";
import { ACTION_BTN, DANGER_BTN } from "./estimateStyles";
import "./WorkTypeTemplateConflictDialog.css";

export function WorkTypeTemplateConflictDialog({
  templateName,
  onReplace,
  onSaveAsNew,
  onClose,
}) {
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useBodyScrollLock(true);

  useEffect(() => {
    function handleKeyDown(event) {
      if (event.key === "Escape" && !saving) {
        onClose?.();
      }
    }

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [onClose, saving]);

  async function runAction(action) {
    setSaving(true);
    setError("");
    try {
      await action();
      onClose?.();
    } catch (actionError) {
      console.error("[WorkTypeTemplateConflictDialog] Action failed:", actionError);
      setError(actionError.message || "Unable to save template.");
    } finally {
      setSaving(false);
    }
  }

  function handleOverlayClick(event) {
    if (event.target === event.currentTarget && !saving) {
      onClose?.();
    }
  }

  if (typeof document === "undefined") return null;

  return createPortal(
    <div className="wt-template-conflict-overlay" onClick={handleOverlayClick}>
      <div
        className="wt-template-conflict-card"
        role="dialog"
        aria-modal="true"
        aria-labelledby="wt-template-conflict-title"
        onClick={(event) => event.stopPropagation()}
      >
        <div id="wt-template-conflict-title" className="wt-template-conflict-title">
          Template Already Exists
        </div>

        <p className="wt-template-conflict-message">
          A template named
        </p>
        <p className="wt-template-conflict-name">&ldquo;{templateName}&rdquo;</p>
        <p className="wt-template-conflict-message">already exists.</p>

        {error && <div className="wt-template-conflict-error">{error}</div>}

        <div className="wt-template-conflict-actions">
          <button
            type="button"
            style={ACTION_BTN}
            disabled={saving}
            onClick={() => runAction(onReplace)}
          >
            {saving ? "Saving…" : "Replace Existing"}
          </button>
          <button
            type="button"
            style={ACTION_BTN}
            disabled={saving}
            onClick={() => runAction(onSaveAsNew)}
          >
            Save as New
          </button>
          <button
            type="button"
            style={DANGER_BTN}
            disabled={saving}
            onClick={onClose}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
}
